import { render } from "./facebookIntegration.vue?vue&type=template&id=79fdd670"
import script from "./facebookIntegration.vue?vue&type=script&lang=js"
export * from "./facebookIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__